import { IOptionData } from "Components/UI/Select";
import {
  FilterOperationType,
  NotificationFilterTypeKeys
} from "Data/interfaces/Notification/IFilters";

export const operationsFormatObj: Record<FilterOperationType, (custom?: boolean) => IOptionData> = {
  equal: (custom?: boolean) => {
    return {
      value: 'equal',
      description: 'é igual a',
      label: custom ? '=' : 'é igual a',
    }
  },
  between: (custom?: boolean) => {
    return {
      value: 'between',
      description: 'é entre',
      label: 'é entre',
    }
  },
  before: (custom?: boolean) => {
    return {
      value: 'before',
      description: 'é antes de',
      label: 'é antes de',
    }
  },
  after: (custom?: boolean) => {
    return {
      value: 'after',
      description: 'é depois de',
      label: 'é depois de',
    }
  },
  onOrBefore: (custom?: boolean) => {
    return {
      value: 'onOrBefore',
      description: 'é em ou antes de',
      label: 'é em ou antes de',
    }
  },
  onOrAfter: (custom?: boolean) => {
    return {
      value: 'onOrAfter',
      description: 'é em ou depois de',
      label: 'é em ou depois de',
    }
  },
};

export const optionsDefaultOperationsObj: Record<NotificationFilterTypeKeys, FilterOperationType> = {
  authorIds: 'equal',
  actions: 'equal',
  csIds: 'equal',
  creationDate: 'equal',
  isRead: 'equal',
};

export const optionsOperationsObj: Record<NotificationFilterTypeKeys, FilterOperationType[]> = {
  authorIds: ['equal'],
  actions: ['equal'],
  csIds: ['equal'],
  creationDate: ['equal', 'between', 'before', 'after', 'onOrBefore', 'onOrAfter'],
  isRead: ['equal'],
};

export const arrayTopicKeysPtBr: Record<string, string> = {
  authorIds: 'Autor',
  actions: 'Ação',
  csIds: 'Obra',
  creationDate: 'Data',
  isRead: 'Lido',
};
